import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ContactoControllerService, AdheridoControllerService, 
   ContactoModel, 
} from 'api-rest';
import { ManagersContactDialogComponent } from '../contact-dialog/contact-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { SpinnerService } from '../../services/spinner.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { SnackbarService } from '../../services/snackbar.service';

const ESTADO_BAJA = 6;

@Component({
  selector: 'managers-agreements-detail-contact-data',
  templateUrl: './detail-contact-data.component.html',
  styleUrls: ['./detail-contact-data.component.scss'],
})
export class DetailContactDataComponent implements OnChanges {
  @Input() acuerdoIndirectoInfo!: any;
  @Input() soloLectura = false;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();
  contactos: ContactoModel[] | undefined = [];

  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  gridArray: ContactoModel[] = [];

  headArray: any = [
    {
      Head: 'Requerida',
      FieldName: 'requerido',
      check: true,
      disabled: true,
    },
    {
      Head: 'Tipo contacto',
      FieldName: 'tipo_contacto',
      Attribute: 'descripcionCorta',
      Tooltip: true,
    },
    {
      Head: 'Tipo entidad',
      renderValue: (value: any) => value.persona ? 'Persona' : 'Empresa'
    },
    {
      Head: 'Nombre/Razón social',
      FieldName: 'fullName',
      Tooltip: true,
    },
    {
      Head: 'Activo',
      FieldName: 'obsoleto',
      renderValue: (item: any) => (item.obsoleto ? 'NO' : 'SI'),
    },
    {
      Head: 'Email',
      FieldName: 'email',
      Tooltip: true,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        // { 'nameButton': "edit", "icon": "edit_square", 'toolTip': 'Editar', 'show': { 'params': 'canAccessListEdit', 'accion': 'edit' } },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'activate',
              name: 'Activar',
              show: { params: 'canAccessActivate', accion: 'activate' },
            },
            {
              nameButton: 'obsolete',
              name: 'Marcar como obsoleto',
              show: { params: 'canAccessObsolete', accion: 'obsolete' },
            }
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];

  constructor(
    private dialog: MatDialog,
    private contactoControllerSrv: ContactoControllerService,
    private adheridoControllerSrv: AdheridoControllerService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.acuerdoIndirectoInfo) {
      this.contactos = this.acuerdoIndirectoInfo?.contactos;
      this.gridArray = this.canAccessAll(this.contactos);
    }
  }

  canAccessAll(list: any) {
    const resultListShow = true
    // this.authService.can(
    //   'adheridos-contactos',
    //   'access'
    // );
    const resultListEdit = true
    // this.authService.can(
    //   'adheridos-contactos',
    //   'update'
    // );
    const resultDelete = true
    // this.authService.can('adheridos-contactos', 'delete');

    const listPermission = list.map((objeto: any) => {
      const estadoUpdatedContact =
        this.acuerdoIndirectoInfo.estado &&
        [2, 3, 4, 5, 6].includes(this.acuerdoIndirectoInfo.estado!.id);
      const estadoEliminar =
        this.acuerdoIndirectoInfo.estado &&
        [1, 2, 3, 4, 5, 6].includes(this.acuerdoIndirectoInfo.estado!.id) &&
        (!objeto.requerido || objeto.requerido === null);
        const esActivo = !objeto.obsoleto;
        //Si el estado es mayor a Pdte Firma Contrato (3) no permitir editar los contactos de Firmante (3) o Rep Autorizado (4)
      const canEditEstadoTipo = (this.acuerdoIndirectoInfo.estado!.id < 3 || (this.acuerdoIndirectoInfo.estado!.id >= 3 && !([3,4].includes(objeto.tipo_contacto?.id))));
      const estadoObsoleto = this.acuerdoIndirectoInfo.estado && [2, 3, 4, 5, 6].includes(this.acuerdoIndirectoInfo.estado!.id);
      return {
        ...objeto,
        canAccessView: resultListShow, //&& esActivo && canEditEstadoTipo,
        canAccessListEdit: !this.soloLectura && resultListEdit && estadoUpdatedContact,
        canAccessDelete: !this.soloLectura && resultDelete && estadoEliminar,
        canAccessObsolete: !this.soloLectura && esActivo && estadoObsoleto,
        canAccessActivate: !this.soloLectura && !esActivo
      };
    });

    return listPermission;
  }

  canAccessExportar(): boolean {
    return this.authService.can('adheridos-contactos', 'access-b-exportar');
  }

  canAccessCreateContact(): boolean {
    return (
      !this.soloLectura &&
      this.authService.can('adheridos-contactos', 'create') &&
      this.acuerdoIndirectoInfo?.estado?.id !== 7
    );
  }

  openModalContact(element?: any): void {
    const dialogRef = this.dialog.open(ManagersContactDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        contacto: element,
        acuerdoIndirecto: this.acuerdoIndirectoInfo,
        soloLectura: this.soloLectura || this.acuerdoIndirectoInfo?.estado?.id === ESTADO_BAJA,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarAdheridoEvent.emit(true);
      }
    });
  }

  checked(item: any) {}

  action(item: any) {
    const row = item?.row ?? item?.item ?? item;
    if (item.nameButton == 'view') {
      this.openModalContact(row);
    } else if (item.nameButton == 'edit') {
      this.openModalContact(row);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(row);
    }else if (item.nameButton == 'activate') {
      this.comprobarContactosActivos(row);
    } else if (item.nameButton == 'obsolete') {
      this.confirmacionMarcarObsoleto(row);
    }
  }
  confirmacionEliminar(element?: ContactoModel): void {
    swal
      .fire({
        text: '¿Desea eliminar el contacto?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.eliminarContacto(element);
        }
      });
  }
  eliminarContacto(element?: ContactoModel) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.contactoControllerSrv.borrarContacto(element.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El contacto se ha eliminado correctamente',
            'success'
          );
          this.refrescarAdheridoEvent.emit(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar el contacto',
            'error'
          );
          console.log(err);
        },
      });
    }
  }

  renderPage(event: number) {
    this.pageNumber = event;
  }

  canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
  comprobarContactosActivos(element?: ContactoModel): void {
    //Si el contacto es de tipo Firmante o Rep Autorizado, solo puede hacer uno activo de cada tipo (incluyendo Empresa/Persona en caso de Rep Autorizado)
    if(element?.tipo_contacto?.id == 3 || element?.tipo_contacto?.id == 4){
      let contactoExistente:any = null;
        if(element?.tipo_contacto?.id == 3){
          contactoExistente = this.contactos?.filter((pContacto:any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id)[0];
        }else{
          contactoExistente = this.contactos?.filter((pContacto:any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id && pContacto.persona == element?.persona)[0];
        }
        if(contactoExistente){
          swal.fire({
            text: `No está permitido activar otro contacto de tipo Firmante o Representante autorizado puesto que ya existe uno activo. ¿Quiere marcar el contacto existente como obsoleto?`,
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sí',
            denyButtonText: 'No',
            allowOutsideClick: false,
          }).then((result: any) => {
            if (result.isConfirmed) {
              this.activarContacto(element, contactoExistente);
            }
          });
        }else{
          this.activarContacto(element);
        }
    }else{
      this.activarContacto(element);
    }
  }

  activarContacto(element?: ContactoModel, contactoExistente?: any){
    if (element?.id) {
      if(contactoExistente){
        contactoExistente.obsoleto = true;
        const pContacto = this.acuerdoIndirectoInfo?.contactos.filter((item:any) => item.id == element.id)[0];
        pContacto.obsoleto = false;
        this.adheridoControllerSrv
          .actualizarAdherido(this.acuerdoIndirectoInfo.id!, this.acuerdoIndirectoInfo)
          .subscribe({
            next: (response) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'El contacto se ha activado correctamente',
                'success'
              );
              this.refrescarAdheridoEvent.emit(true);
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Ha ocurrido un error al activar el contacto',
                'error'
              );
              console.log(err);
            },
          });

      }else{
        element.obsoleto = false;
        this.spinnerSrv.loadingShow();
        this.contactoControllerSrv.actualizarContacto(element.id, element).subscribe({
          next: (response) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'El contacto se ha activado correctamente',
              'success'
            );
            this.refrescarAdheridoEvent.emit(true);
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al activar el contacto',
              'error'
            );
            console.log(err);
          },
        });
      }
    }
  }

  confirmacionMarcarObsoleto(element?: ContactoModel): void {
    swal
      .fire({
        text: '¿Desea marcar el contacto como obsoleto?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.marcarContactoObsoleto(element);
        }
      });
  }

  marcarContactoObsoleto(element?: ContactoModel) {
    if (element?.id) {
      element.obsoleto = true;
      this.spinnerSrv.loadingShow();
      this.contactoControllerSrv.actualizarContacto(element.id, element).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El contacto se ha marcado como obsoleto',
            'success'
          );
          this.refrescarAdheridoEvent.emit(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al marcar el contacto como obsoleto',
            'error'
          );
          console.log(err);
        },
      });
    }
  }

}

